import {IconInfo} from "@/pb/api/devplan/types/common";
import Image from "next/image";
import React from "react";
import * as Lucide from "lucide-react";
import {cn} from "@/lib/utils";

export type IconSize = 'sm' | 'lg' | 'xs'

export function IconView({icon, size, noPlaceholder}: { icon: IconInfo, size?: IconSize, noPlaceholder?: boolean }) {
  const {path, lucideIcon} = icon
  if (path && path.trim().length > 0) {
    return <Image unoptimized src={path} alt="icon" height={50} width={50} className={
      cn(size === 'sm' ? 'size-6' : (size === 'xs' ? 'size-4' : 'size-16'))
    }/>
  }
  if (lucideIcon) {
    const {name, color} = lucideIcon
    return <LucideNamedIcon name={name} color={color} size={size}/>
  }
  if (noPlaceholder) {
    return null
  }
  return <IconPlaceholder size={size}/>
}

export function IconPlaceholder({size}:{size?: IconSize}) {
  return <div className={cn(
    "flex items-center justify-center text-xs bg-muted",
    size === 'sm' ? 'size-6 rounded' : 'size-16 rounded-lg'
  )}>
    {size === 'sm' ? "_" : "Icon"}
  </div>
}

const sizes: Record<string, number> = {
  'sm': 2,
  'xs': 2.5
}
const defaultSize = 1.5

export function LucideNamedIcon(
  {
    name, className, color, size, onClick,
  }: { name: string, className?: string, color?: string, size?: IconSize, onClick?: () => void }) {
  // @ts-expect-error name is a generic string here by design
  const IconComponent = Lucide[name];
  if (!IconComponent) {
    return <IconPlaceholder size={size}/>
  }
  const sizeVal = size ? (sizes[size] || defaultSize) : defaultSize
  return <div
    className={cn(
      "size-16 rounded-lg p-2 flex items-center justify-center",
      size === 'sm' && 'size-6 p-1 rounded',
      size === 'xs' && 'size-5 p-1/2 rounded',
      className)}
    style={{backgroundColor: color}}
    onClick={onClick}
  >
    <IconComponent strokeWidth={sizeVal} className={cn(
      "text-white size-10",
      size === 'sm' && 'size-4',
      size === 'xs' && 'size-4',
    )}/>
  </div>
}